module.exports = "/_next/static/images/b2cc5583cac7a8d0169d546cf51ee61d-mgm-invite-ticket-2.jpg.webp";